/** @typedef {import('./types.js').BehavioralCategory} BehavioralCategory */
/** @typedef {import('./types.js').LockboxRulepack} LockboxRulepack */

/**
 * Categories a focus mode considers distracting (suggestion template).
 * Enforcement uses `modeStrict.extraBlockCategories` after user taps Block All.
 * @type {Record<string, BehavioralCategory[]>}
 */
export const MODE_POLICY_BLOCKED_CATEGORIES = {
  work: ["anime_streaming", "manga_reading", "shortform_feed", "entertainment_discovery"],
  strict: [
    "anime_streaming",
    "manga_reading",
    "shortform_feed",
    "entertainment_discovery",
    "gaming_session",
  ],
  sleep: ["shortform_feed", "gaming_session", "entertainment_discovery", "anime_streaming"],
};

/**
 * @param {string} modeId
 * @param {LockboxRulepack} rulepack
 * @returns {BehavioralCategory[]}
 */
export function getModeBlockedCategories(modeId, rulepack) {
  const rule = rulepack.modeStrict.find((m) => m.modeId === modeId);
  if (rule?.blockedCategories?.length) return [...rule.blockedCategories];
  return MODE_POLICY_BLOCKED_CATEGORIES[modeId] ? [...MODE_POLICY_BLOCKED_CATEGORIES[modeId]] : [];
}

/**
 * Categories currently enforced for this mode (user enabled via Block All / toggles).
 * @param {string} modeId
 * @param {LockboxRulepack} rulepack
 * @returns {BehavioralCategory[]}
 */
export function getModeEnforcedCategories(modeId, rulepack) {
  const rule = rulepack.modeStrict.find((m) => m.modeId === modeId);
  return rule?.extraBlockCategories ? [...rule.extraBlockCategories] : [];
}
